// ============================================================
// MOCK CORSI — da sostituire con chiamate API reali
// ============================================================

import { CartCourse } from '../types/cart';

export const MOCK_COURSES: CartCourse[] = [
  {
    id: 'be-smart',
    title: 'BE SMART',
    subtitle: 'Il manuale per chi studia o lavora "in smart"',
    price: 74,
    originalPrice: undefined,
    imageUrl: undefined,
  },
  // be-xpert, be-free, be-strong, be-power, be-you → comingSoon, nessun prezzo
];

export const getCourseById = (id: string): CartCourse | undefined =>
  MOCK_COURSES.find((c) => c.id === id);
